import { ConnectButton } from "@rainbow-me/rainbowkit";
import { Link } from "react-router-dom";
import { AppSidebar } from "@/components/app-sidebar";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/breadcrumb";
import { Separator } from "@/components/separator";
import { SidebarInset, SidebarProvider, SidebarTrigger } from "@/components/sidebar";
import { SiloRewardCalculatorPanel } from "@/components/silo/silo-reward-calculator-panel";
import { useStats } from "@/providers/global-data.provider";
import { RiDatabase2Line } from "@remixicon/react";

export default function SiloRewardCalculatorPage() {
  const { price: lrsPriceUsd } = useStats();

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <div className="px-4 md:px-6 lg:px-8 @container">
          <div className="w-full max-w-6xl mx-auto">
            <header className="flex flex-wrap gap-3 min-h-20 py-4 shrink-0 items-center transition-all ease-linear border-b">
              <div className="flex flex-1 items-center gap-2">
                <SidebarTrigger className="-ms-1" />
                <div className="max-lg:hidden lg:contents">
                  <Separator orientation="vertical" className="me-2 data-[orientation=vertical]:h-4" />
                  <Breadcrumb>
                    <BreadcrumbList>
                      <BreadcrumbItem className="hidden md:block">
                        <BreadcrumbLink asChild>
                          <Link to="/">Home</Link>
                        </BreadcrumbLink>
                      </BreadcrumbItem>
                      <BreadcrumbSeparator className="hidden md:block" />
                      <BreadcrumbItem>
                        <BreadcrumbLink asChild>
                          <Link to="/silo">SILO</Link>
                        </BreadcrumbLink>
                      </BreadcrumbItem>
                      <BreadcrumbSeparator className="hidden md:block" />
                      <BreadcrumbItem>
                        <BreadcrumbPage>Reward calculator</BreadcrumbPage>
                      </BreadcrumbItem>
                    </BreadcrumbList>
                  </Breadcrumb>
                </div>
              </div>
              <ConnectButton />
            </header>

            <div className="py-6">
              <div className="flex justify-between items-center flex-wrap gap-3">
                <div className="flex items-center">
                  <div className="w-1 h-8 bg-[#FF8A3C] mr-3"></div>
                  <h1 className="text-3xl font-bold">SILO reward calculator</h1>
                </div>
                <div className="inline-flex items-center gap-2 rounded-md border border-[#FF8A3C]/40 bg-[#FF8A3C]/10 px-3 py-2 text-xs text-[#FFD3B3]">
                  <RiDatabase2Line className="size-4 text-[#FF8A3C]" />
                  Stake in LRS; storage converted to bytes; optional uptime.
                </div>
              </div>

              <p className="text-muted-foreground mb-6 max-w-3xl mt-4">
                Estimate rewards from stake, storage (GB/TB/PB → bytes), and optional uptime. Results include USD where a
                global LRS price is available.
              </p>

              <SiloRewardCalculatorPanel lrsUsdPrice={lrsPriceUsd} />
            </div>
          </div>
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
